// import { useSelector } from "react-redux"
// import { selectNoteById } from "./notesApiSlice"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"

import { useGetNotesQuery } from "./notesApiSlice"
import {memo} from 'react'

const Note = ({noteId}) => {

  const {note} = useGetNotesQuery('notesList',{
     selectFromResult: ({data}) => ({
        note: data?.entities[noteId]
     }),
  })
  // const note = useSelector(state => selectNoteById(state, noteId)) 
  //The above note has been removed and a new new note from the useGetNotesQuery has been used so we can get the note data from the data that is queried , as the previous one was createing a new query but using the new one we will just get it directly from the database

  const navigate = useNavigate()

  if(note){
    const created = new Date(note.createdAt).toLocaleDateString('en-US', {day:'numeric', month: 'long'})
    const updated = new Date(note.updatedAt).toLocaleDateString('en-Us',{ day: 'numeric', month: 'long'})
    // const handleEdit = navigate(`/dash/notes/${noteId}`) // This was giving error and the error is:1) You should call navigate() in a React.useEffect(), not when your component is first rendered.2)Cannot update a component (`BrowserRouter`) while rendering a different component (`Note`). To locate the bad setState() call inside `Note`, follow the stack trace as described in https://react.dev/link/setstate-in-render 3) and also when the route it was going to a randome userId "dash/notes/68b02c1653194a3af6ba978e" instead of just this "dash/notes/"
    const handleEdit = () => navigate(`/dash/notes/${noteId}`)

    return (
      <tr className="table__row">
        <td className="table__cell note__status"> {note.completed?<span className="note__status--completed">Completed</span>:<span className="note__status--open">Open</span>}</td>
        <td className="table__cell note__created">{created}</td>
        <td className="table__cell note__updated">{updated}</td>
        <td className="table__cell note__title">{note.title}</td>
        <td className="table__cell note__username">{note.username}</td>
        <td className="table__cell"><button className="icon-button table__button" onClick={handleEdit}><FontAwesomeIcon icon={faPenToSquare}/></button></td>
      </tr>

    )
  } else return null
}
// By doing this, this componenet will only be rerender if there is a change in the data
const memoizedNote = memo(Note)

// export default Note
export default memoizedNote